import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDevices: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="devices, macbook, iphone, phone, connected"><path d="M14.25 8.75H22.25V21.25H14.25V8.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M17.25 18.25H19.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.25 8.75V3.75H3.75V16.75H1.75V20.25H14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 16.75H14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDevices;
